module.exports = __webpack_public_path__ + "img/syukyaku-top-pa003sp.00f43664.png";